var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VMenu',{attrs:{"triggers":['hover', 'focus']},scopedSlots:_vm._u([{key:"popper",fn:function(){return [_vm._v(" "+_vm._s(_vm.content)+" ")]},proxy:true}])},[_c('a',[_c('HelpCircle')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }